// Teams-projectkanaal: statussleutels uit de engine (services/teams_kanaal.py) → gewone Nederlandse labels.
// Gedeeld door Admin → Teams-kanaalsjabloon en de projectflow-regel.

const LABEL = {
  nieuw: 'Nieuw',
  wacht: 'Wacht — later opnieuw',
  aanmaken: 'Wordt aangemaakt',
  aangemaakt: 'Kanaal aangemaakt',
  gekoppeld: 'Bestaand kanaal gekoppeld',
  dry: 'Proefrun — niets aangemaakt',
  team_ontbreekt: 'Geen klantteam gevonden',
  geen_toegang: 'Geen toegang tot Teams (recht ontbreekt)',
  fout: 'Mislukt',
  gestopt: 'Gestopt',
  bezig: 'Bezig',
  off: 'Uit',
};

const KLEUR = {
  aangemaakt: 'success', gekoppeld: 'success', dry: 'default', wacht: 'warning',
  team_ontbreekt: 'warning', geen_toegang: 'error', fout: 'error', aanmaken: 'warning',
  gestopt: 'default', nieuw: 'default',
};

/** Label voor een rij ({status, team_name, plan}) of een losse statussleutel. */
export function teamsKanaalStatusLabel(rijOfStatus) {
  const rij = typeof rijOfStatus === 'string' ? { status: rijOfStatus } : (rijOfStatus || {});
  const status = rij.status || '';
  // 'team_ontbreekt' mét gevonden team = het team is er, maar gasten blokkeren automatisch aanmaken.
  if (status === 'team_ontbreekt' && (rij.team_name || rij.plan?.team?.name)) {
    // Oudere rijen (vóór de status geen_toegang): de 403 staat alleen in de waarschuwingen van het plan.
    const geenRecht = rij.plan?.toegang_ontbreekt
      || (rij.plan?.waarschuwingen || []).some((w) => /Graph 40[13]/.test(w));
    return geenRecht ? LABEL.geen_toegang : 'Team gevonden — bevestiging nodig (gasten)';
  }
  if (LABEL[status]) return LABEL[status];
  return status ? status.replace(/_/g, ' ') : '—';
}

export function teamsKanaalStatusKleur(status) {
  return KLEUR[status] || 'default';
}
